<div class="my-3 pull-right">
	<i class="fa fa-2x m-1 pointer fa-arrow-circle-left" (click)="doPagination(true)" *ngIf="showLeft" title="Back"></i>
	<i class="fa fa-2x m-1 pointer fa-arrow-circle-right" (click)="doPagination()" *ngIf="showRight" title="Next"></i>
</div>